import * as React from "react";


let ReactDOM = require("react-dom");
let sketch=require('../../../../lib/react-color/components/sketch/Sketch').default;

export class ColorPopover extends React.Component<ColorPopoverProps, ColorPopoverState> {
    static defaultProps: Partial<ColorPopoverProps> = {
        Container:null,
        Visible:false,
        FixedPosition:false
    };

    public lastColor:any;
    constructor(props: ColorPopoverProps) {
        super(props);
        this.state = {};
    }

    public render() {

        const styles = {

                color: {
                    width: '18px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.props.ColorToUse
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '10000000',
                    top:this.props.Container?(this.props.Container.getBoundingClientRect().top+window.scrollY+this.props.Container.getBoundingClientRect().height+1)+'px':null,
                    left:this.props.Container?(this.props.Container.getBoundingClientRect().left+window.scrollX)+'px':null,
                    border:'1px #dfdfdf solid',
                    borderRadius:10
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },

        };

        if(this.props.FixedPosition)
        {
            styles.popover.position='fixed';
            styles.popover.top=this.props.Container?(this.props.Container.getBoundingClientRect().top+this.props.Container.getBoundingClientRect().height+1)+'px':null;
            styles.popover.left=this.props.Container?(this.props.Container.getBoundingClientRect().left)+'px':null;
        }


        if(this.props.Visible)
            return ReactDOM.createPortal( (
                <div  style={ styles.popover as any } className={'rnColorPopOver rednao'}>
                    <div style={ styles.cover as any } onClick={ e=>{this.setState({ displayColorPicker: false })} }/>
                    <div onMouseDown={x=>x.stopPropagation()}>
                        {React.createElement(sketch,{color:this.props.ColorToUse,onChange:e=>{this.lastColor=e.hex;}})}
                        <div style={{backgroundColor:'white',borderBottomRightRadius:10,borderBottomLeftRadius:10, textAlign:'center',marginBottom:2,position:'relative',zIndex:10}}>
                            <button className={'rnbtn rnbtn-primary'} onMouseDown={e=>this.props.ColorChanged&&this.props.ColorChanged(this.lastColor)} >Select</button>
                        </div>
                    </div>
                </div>
            ),document.body);
        return null;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ColorPopoverProps {
    Container:HTMLDivElement;
    Visible:boolean;
    ColorToUse:any;
    LastColor:any;
    ColorChanged:(color:any)=>void;
    FixedPosition:boolean;
}

interface ColorPopoverState {

}

//#endregion "My Region"